import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    const handlePopState = () => {
      // popstate 후 브라우저가 스크롤 복원한 뒤 다시 올리기
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 30); // 10~50ms 정도면 충분
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [pathname]);

  return null;
}
